module.exports = __webpack_public_path__ + "static/media/mob_alert_partner_gold_x2.e970c471.png";